import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { toast } from "react-toastify"
import { loaderStart, loaderStop } from "../features/HomeMaster"
import { ScoreCard } from "./ScoreCard"
import { Livehorsetv } from "./Tv"

export const TradeMarket = () => {
    const [datam, setdata] = useState([])
    const [dataF, setdataF] = useState([])
    const [resultPop, setResultPop] = useState()
    const [selectedEventType, setSelectedEventType] = useState("All");
    const [selectedEventName, setSelectedEventName] = useState("All");
    const [showTV, setShowTV] = useState(false); // Toggle for TV

    const loader = useSelector(state => state.homeMaster?.loader)
    const dispatch = useDispatch()

    const fetchTradeDetails = async () => {
        const data = await fetch('https://webapi.demoxyzapi.com/api/v1/admin/gettrademarketsall')
        const data2 = await fetch('https://webapi.demoxyzapi.com/api/v1/admin/gettrademarketsall')
        let resData = await data.json()
        let resData2 = await data2.json()
        let setss = []
        let fulldata = []
        for (let i = 0; i < resData.data.length; i++) {
            const element = resData.data[i];
            fulldata.push(element)
            let isexist = setss.find(a => a.eventName === element.eventName)
            if (isexist) {
                let isMidExist = isexist.data.find(a => a.marketId == element.marketId)
                if (!isMidExist) {
                    isexist.data.push(element)
                }
            } else {
                setss.push({
                    eventName: element.eventName,
                    data: [element]
                })
            }
        }
        for (let i = 0; i < resData2.data.length; i++) {
            const element = resData2.data[i];
            fulldata.push(element)
            let isexist = setss.find(a => a.eventName === element.eventName)
            if (isexist) {
                let isMidExist = isexist.data.find(a => a.marketId == element.marketId)
                if (!isMidExist) {
                    isexist.data.push(element)
                }
            } else {
                setss.push({
                    eventName: element.eventName,
                    data: [element]
                })
            }
        }
        setdata(setss)
        setdataF(fulldata)
    }

    const [resultData, setResultData] = useState({
        winerId: "",
    })

    const openResultPop = (data) => {
        setResultPop(data)
    }

    const giveResultToPOSTGFANCY = async (mid, wid) => {
        const bodyData = { "mid": mid, "sid": wid }
        try {
            const res2 = await fetch('https://webapi.demoxyzapi.com/api/v1/result/postresultfancy', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(bodyData)
            })
            const data2 = await res2.json()
            if (data2.status === 'success') toast.success("result updated to 4MAGIC")
        } catch (error) { }
        try {
            const res3 = await fetch('https://webapi.demoxyzapi.com/api/v1/result/postresultfancy', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(bodyData)
            })
            const data2 = await res3.json()
            if (data2.status === 'success') toast.success("result updated to BESTFAIR")
        } catch (error) { }
        try {
            const res22 = await fetch('https://masterpg.9xxbet.com/api/v1/result/postresultfancy', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(bodyData)
            })
            const data2 = await res22.json()
            if (data2.status === 'success') toast.success("result updated to MASTERSERVER")
        } catch (error) { }
    }

    const giveResultToPOSTGNORMAL = async (mid, wid) => {
        const bodyData = { "mid": mid, "sid": wid }
        try {
            const res2 = await fetch('https://webapi.demoxyzapi.com/api/v1/result/postresultnormal', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(bodyData)
            })
            const data2 = await res2.json()
            if (data2.status === 'success') toast.success("result updated to 4MAGIC")
        } catch (error) { }
        try {
            const res3 = await fetch('https://webapi.demoxyzapi.com/api/v1/result/postresultnormal', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(bodyData)
            })
            const data2 = await res3.json()
            if (data2.status === 'success') toast.success("result updated to BESTFAIR")
        } catch (error) { }
        try {
            const res22 = await fetch('https://masterpg.9xxbet.com/api/v1/result/postresultnormal', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(bodyData)
            })
            const data2 = await res22.json()
            if (data2.status === 'success') toast.success("result updated to MASTERSERVER")
        } catch (error) { }
    }

    const onResultSelectChange = (e) => {
        setResultData({ ...resultData, winerId: e.target.value })
    }

    const saveResult = async (mid, wid, name) => {
        if (window.confirm("Please confirm winner that is " + wid + " for " + name)) {
            if (window.confirm("Please confirm again your winner id = " + wid + " and runner = " + name)) {
                giveResultToPOSTGFANCY(mid, wid)
                return
            }
        }
        return
    }

    const saveResultToNormal = async (mid, wid, name) => {
        if (window.confirm("Please confirm winner that is " + wid + " for " + name)) {
            if (window.confirm("Please confirm again your winner id = " + wid + " and runner = " + name)) {
                giveResultToPOSTGNORMAL(mid, wid)
                return
            }
        }
        return
    }

    const onResultDChange = (e) => {
        setResultData({ ...resultData, [e.target.name]: e.target.value })
    }

    useEffect(() => {
        fetchTradeDetails()
        let a = setInterval(() => {
            fetchTradeDetails()
        }, 50000);
        return () => {
            clearInterval(a)
        }
    }, [])

    const eventTypes = ["All"];
    datam?.forEach(d => {
        d.data.forEach(a => {
            if (!eventTypes.includes(a.eventTypeName)) {
                eventTypes.push(a.eventTypeName);
            }
        });
    });

    const eventNames = ["All"];
    datam?.forEach(d => {
        d.data.forEach(a => {
            if (
                (selectedEventType === "All" || a.eventTypeName === selectedEventType) &&
                !eventNames.includes(a.eventName)
            ) {
                eventNames.push(a.eventName);
            }
        });
    });

    const eventId = dataF.find(x => x.eventName == selectedEventName)?.eventId
    let eventTypeId = dataF.find(x => x.eventTypeName == selectedEventType || x.eventName == selectedEventName)?.eventTypeId
    eventTypeId = eventTypeId == 0 ? 4 : eventTypeId == 13 ? 4 : eventTypeId

    return (
        <>
            <div style={{ marginTop: '50px' }} className='page-body-wrapper overflow-auto'>
                <div className="main-panel overflow-auto">
                    <div className="content-wrapper overflow-auto">
                        <div className="row overflow-auto">
                            {/* Score + TV Section with Toggle */}
                            {
                                selectedEventName != "All" && eventId && eventTypeId && (
                                    <div className="d-flex align-items-center gap-2 mb-3">
                                        <div className="form-check form-switch">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                role="switch"
                                                id="tvToggle"
                                                checked={showTV}
                                                onChange={(e) => setShowTV(e.target.checked)}
                                            />
                                            <label className="form-check-label" htmlFor="tvToggle">
                                                Show Live TV
                                            </label>
                                        </div>
                                    </div>
                                )
                            }

                            {
                                selectedEventName != "All" && eventId && eventTypeId ? (
                                    <div className="d-flex gap-2 w-100">
                                        <div style={{ width: showTV ? '50%' : '100%', transition: 'width 0.3s ease' }}>
                                            <ScoreCard eventId={eventId} sportId={eventTypeId} />
                                        </div>
                                        {showTV && (
                                            <div style={{ width: '50%' }}>
                                                <Livehorsetv id={eventId} />
                                            </div>
                                        )}
                                    </div>
                                ) : null
                            }

                            {/* Event Type Buttons */}
                            <div className="mb-3 d-flex flex-wrap gap-2">
                                {
                                    eventTypes.map(type => (
                                        <button
                                            key={type}
                                            className={`btn ${selectedEventType === type ? "btn-primary" : "btn-outline-primary"}`}
                                            onClick={() => setSelectedEventType(type)}
                                        >
                                            {type}
                                        </button>
                                    ))
                                }
                            </div>

                            {/* Event Name Select */}
                            <div className="mb-3">
                                <select
                                    className="form-select w-auto"
                                    value={selectedEventName}
                                    onChange={(e) => setSelectedEventName(e.target.value)}
                                >
                                    {
                                        eventNames.map(name => (
                                            <option key={name} value={name}>{name}</option>
                                        ))
                                    }
                                </select>
                            </div>

                            {/* Table */}
                            <div className="col-md-12 overflow-auto">
                                <table className="table table-striped table-bordered overflow-auto">
                                    <thead className="table-dark">
                                        <tr>
                                            <th>
                                                MarketName{' '}
                                                <button
                                                    className="btn btn-sm btn-light ms-2"
                                                    onClick={() => fetchTradeDetails()}
                                                >
                                                    Refresh
                                                </button>
                                            </th>
                                            <th>EventName</th>
                                            <th>EventType</th>
                                            <th>Market Time</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            datam?.map(d => (
                                                d.data
                                                    .filter(a =>
                                                        (selectedEventType === "All" || a.eventTypeName === selectedEventType) &&
                                                        (selectedEventName === "All" || a.eventName === selectedEventName)
                                                    )
                                                    .map(a => (
                                                        <tr key={a.marketId}>
                                                            <td>
                                                                <div className="d-flex justify-content-between align-items-center flex-wrap gap-1">
                                                                    <span>{a.marketName}</span>
                                                                    <div className="d-flex gap-1">
                                                                        <button
                                                                            data-bs-toggle="modal"
                                                                            data-bs-target="#result-popup"
                                                                            onClick={() => {
                                                                                setResultData({ winerId: "" })
                                                                                openResultPop(a)
                                                                            }}
                                                                            className="btn btn-sm btn-primary text-white"
                                                                        >
                                                                            Close
                                                                        </button>
                                                                        <button
                                                                            data-bs-toggle="modal"
                                                                            data-bs-target="#delete-popup"
                                                                            onClick={() => {
                                                                                setResultData({ winerId: "" })
                                                                                openResultPop(a)
                                                                            }}
                                                                            className="btn btn-sm btn-danger text-white"
                                                                        >
                                                                            Delete
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>{a.eventName}</td>
                                                            <td>{a.eventTypeName}</td>
                                                            <td>{new Date(a.marketTime).toLocaleString()}</td>
                                                            <td>{/* result / status if needed */}</td>
                                                        </tr>
                                                    ))
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Delete Popup */}
                <div id="delete-popup" tabIndex="-1" aria-labelledby="delete-popup" className="modal fade" aria-modal="true" role="dialog" style={{ display: "none" }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            {
                                loader ? (
                                    <div className="p-3">Loading...</div>
                                ) : (
                                    <>
                                        <div className="modal-header text-dark">
                                            <h1 id="book-deal-popupLabel" className="modal-title fs-5 text-uppercase">
                                                {resultPop && resultPop.stMarketName || resultPop?.marketName}
                                            </h1>
                                            <button type="button" data-bs-dismiss="modal" aria-label="Close" className="btn-close"></button>
                                        </div>
                                        <div className="modal-body">
                                            <div className='mb-3'>Do you want to delete this market?</div>
                                            <button
                                                onClick={() => {
                                                    dispatch(loaderStart())
                                                    saveResult(resultPop.stMarketID || resultPop.marketId, "Delete", resultPop.stMarketName || resultPop?.marketName).then((data) => {
                                                        if (data?.success) {
                                                            toast.success("Result has been uploaded successfully")
                                                        } else {
                                                            toast.error("Server error")
                                                        }
                                                        dispatch(loaderStop())
                                                    })
                                                }}
                                                className='btn btn-danger'
                                            >
                                                Delete
                                            </button>
                                        </div>
                                    </>
                                )
                            }
                        </div>
                    </div>
                </div>

                {/* Result Popup */}
                <div id="result-popup" tabIndex="-1" aria-labelledby="result-popup" className="modal fade" aria-modal="true" role="dialog" style={{ display: "none" }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            {
                                loader ? (
                                    <div className="p-3">Loading...</div>
                                ) : (
                                    <>
                                        <div className="modal-header text-dark">
                                            <h1 id="book-deal-popupLabel" className="modal-title fs-5 text-uppercase">
                                                {resultPop && resultPop.stMarketName || resultPop?.marketName}
                                            </h1>
                                            <button type="button" data-bs-dismiss="modal" aria-label="Close" className="btn-close"></button>
                                        </div>
                                        <div className="modal-body">
                                            {
                                                resultPop?.eventTypeName !== 'Fancy' && !resultPop?.marketName.includes('Line') ? (
                                                    <div className='my-3'>
                                                        <select className="form-select" onChange={onResultSelectChange} name="winerId" value={resultData.winerId}>
                                                            <option value="" disabled>Select winner from below</option>
                                                            <option value="1111111">Other</option>
                                                            {
                                                                JSON.parse(resultPop?.runners ? resultPop?.runners : '[]')?.map((x) => (
                                                                    <option key={x.selectionId} value={x.selectionId}>{x.runnerName}</option>
                                                                ))
                                                            }
                                                            <option value="Delete">Delete</option>
                                                        </select>
                                                    </div>
                                                ) : (
                                                    <div className="my-3">
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            placeholder="Enter winner ID"
                                                            onChange={onResultDChange}
                                                            value={resultData.winerId}
                                                            name='winerId'
                                                        />
                                                    </div>
                                                )
                                            }
                                            <button
                                                onClick={() => {
                                                    dispatch(loaderStart())
                                                    resultPop?.eventTypeName !== 'Fancy' && !resultPop?.marketName.includes('Line')
                                                        ? saveResultToNormal(resultPop.stMarketID || resultPop.marketId, resultData.winerId, resultPop.marketName)
                                                        : saveResult(resultPop.stMarketID || resultPop.marketId, resultData.winerId, resultPop.stMarketName || resultPop.marketName).then((data) => {
                                                            if (data?.success) {
                                                                toast.success("Result has been uploaded successfully")
                                                            } else {
                                                                toast.error("Server error")
                                                            }
                                                        })
                                                    dispatch(loaderStop())
                                                }}
                                                data-bs-dismiss="modal"
                                                className='btn btn-danger'
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}